<template>
	<div class="returnpassword">
		<div class="top">
			<img class="logo" src="../../static/img/logo.png" />
			<h5 class="top_tit"><span>|</span> 会员系统</h5>
			<router-link class="back"  to="/login">
				返回登录
			</router-link>
		</div>
		<div class="con">
			<div class="tc" v-show="tc">
				<div class="tc_tit">
					<img class="tc_img" src="../../static/img/icon7.png" />
					提交成功
				</div>
				<p>密码找回申请，审核需7个工作日，审核成功后，请前往邮箱查看</p>
				<button class="close" @click="close">确定</button>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm ">
			    <h3 class="title"><span></span><strong>找回密码</strong></h3>	
			    <div class="middle">
			    	 <!--用户名-->
				    <div class="iptbox">
				    	<span>单位名称</span>	
				    	<el-form-item style="width: 300px;height: 40px;float: right;margin-bottom: 0;"  prop="account">	    	
					      	<el-input class="user" type="text" v-model="ruleForm.account" auto-complete="off" placeholder="请输入单位名称" clearable></el-input>
					    </el-form-item>
				    </div>
				    
			    	<div class="iptbox">
			    		<span>输入邮箱</span>
			    		<el-form-item style="width: 300px;height: 40px;float: right;margin-bottom: 0;"
						    prop="email"
						    :rules="[
						      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
						      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
						    ]"
						>						
						    <el-input class="email" v-model="ruleForm.email" placeholder="请填写接收找回密码的邮箱" clearable></el-input>
						</el-form-item>
			    	</div>
				    
				    <!--验证码-->
				    <div class="drag" ref="dragDiv">
				        <div class="drag_bg"></div>
				        <div class="drag_text">{{confirmWords}}</div>
				        <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;"></div>
				   </div>
				    <div class="add" >
				    	<label for="file"></label>
				    	<input type="file" id="file" class="file" @change="uploadFile($event)" multiple="multiple" >
				    </div>
				    <p class="note">支持扩展名： .pdf .doc</p>
				    <p class="note1">企业可选择提交申请表并加盖企业或企业部门公章进行密码 找回（上传文件1MB以内）<a class="down_load">下载密码找回申请表</a> </p>
				    <!--提交-->	
				    <el-form-item style="width: 160px;display: block;margin: 0 auto;">
				      	<el-button class="btn" type="primary" style="width:100%;" @click.native.prevent="onSubmit" >提交</el-button>
				    </el-form-item>
			    </div>
			</el-form>
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
	import Qs from 'qs'
	import bottom from './Bottom'
  	export default {
  		components: {
			bottom
		},
	    data() {	    	
		    return {
		    	tc:false,
		    	beginClientX:0,           /*距离屏幕左端距离*/
		        mouseMoveStata:false,     /*触发拖动状态  判断*/
		        maxwidth:'',               /*拖动最大宽度，依据滑块宽度算出来的*/
		        confirmWords:'拖动滑块验证',   /*滑块文字*/
		        confirmSuccess:false,          /*验证成功判断*/		       
		      	file:'',
		      	filename:'',
		        ruleForm: {
		        	account: '',
			        email:'',
		        },
		        rules: {
		        	account: [
			            { required: true, message: '请输入单位名称', trigger: 'blur' },
			        ],
		        }
		    };
	    },
		created() {
	  	},
	  	mounted() {
		   	this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
	        document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
	        document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn)
		},
	    methods: {
	    	mousedownFn:function (e) {
                if(!this.confirmSuccess){
                    e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
                    this.mouseMoveStata = true;
                    this.beginClientX = e.clientX;
                }
            },        //mousedoen 事件
            successFunction(){
                this.confirmSuccess = true
                this.confirmWords = '验证通过';
                if(window.addEventListener){
                    document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
                }else {
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
                }
                document.getElementsByClassName('drag_text')[0].style.color = '#fff'
                document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
                document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
            },                //验证成功函数
            mouseMoveFn(e){
                if(this.mouseMoveStata){
                    let width = e.clientX - this.beginClientX;
                    if(width>0 && width<=this.maxwidth){
                        document.getElementsByClassName('handler')[0].style.left = width + 'px';
                        document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
                    }else if(width>this.maxwidth){
                        this.successFunction();
                    }
                }
            },                   //mousemove事件
            moseUpFn(e){
                this.mouseMoveStata = false;
                var width = e.clientX - this.beginClientX;
                if(width<this.maxwidth){
                    document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
                    document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
                }
            },               
		    uploadFile(event){
		    	console.log(event.target.files[0])
		      	const isLt2M = event.target.files[0].size / 1024 / 1024 < 1 // 上传头像图片大小不能超过 2MB
		      	if (!isLt2M) {
		      		this.$toast('图片选择失败，每张图片大小不能超过 1MB,请重新选择!');
			    } else {
			     	this.file = event.target.files[0]; //获取input的图片file值
			     	this.filename = event.target.files[0].name;
			    }
		   },
		    onSubmit(ev) {
		        this.$refs.ruleForm.validate((valid) => {
		        	if (valid) {
			            if(!this.confirmSuccess){
			            	this.$toast('请通过验证');
	        				return false;
			            };
			            if(this.filename == ""){
						   this.$toast('请选择要上传的文件！')
						   return false
						}
			            let fileFormData = new FormData();
						fileFormData.append('file', this.file, this.filename);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名
						console.log(fileFormData.get('file'));
						fileFormData.append('company_name',this.ruleForm.account);
						fileFormData.append('email',this.ruleForm.email);
						let requestConfig = {
								headers: {
								 	'Content-Type': 'multipart/form-data'
								},
						};
			            this.$axios.post('user/retrievepass',fileFormData,requestConfig).then(response => {
			            	console.log(response.data);
					            if(response.data.state==5){
					            	this.tc=true;
					            }else{
					            	this.$toast(response.data.msg);
					            }
						});	
			        }
		        	
		       });	
		    },
		    close(){
		    	this.tc=false;
		    }
	    }
	}

</script>
<style scoped >
.returnpassword{
	width: 100%;
	height: auto;
	background: #fff;
	font-family:PingFangSC-Medium;
	font-size:20px;
	color:rgba(0,0,0,0.45);
}
.top{
	height:80px ;
	position: relative;
}
.logo{
	width: 211px;
	height: 43px;
	position: absolute;
	top: 16px;
	left: 254px;
}
.top_tit{
	position: absolute;
	top: 26px;
	left: 480px;
	height:28px;
	font-weight:bold;
	color:rgba(0,94,179,1);
	line-height:28px;
}
.top_tit span{
	height:17px;
	color: #E8E8E8;
}
.back{
	position: absolute;
	top: 30px;
	right: 249px;
	font-size:14px;
	font-weight:bold;
	color:rgba(128,128,128,1);
	line-height:20px;
}
.con{
	position: relative;
	border-top: 1px solid rgba(0,0,0,0);
	box-sizing: border-box;
	width: 100%;
	height: 600px;
	background:rgba(246,248,249,1);
	font-size: 14px;
}
.tc{
	text-align: left;
	position: fixed;
  	top: 50%;
  	left: 50%;
  	transform: translate(-50%, -50%);
	width:433px;
	height:192px;
	background:rgba(255,255,255,1);
	box-shadow:0px 4px 12px 0px rgba(0,0,0,0.2);
	border-radius:4px;
	padding: 32px 32px 0 70px;
	box-sizing: border-box;
	z-index: 99;
	color:rgba(0,0,0,0.65);
}
.tc_tit{
	position: relative;
	width: 100%;
	height: 24px;
	line-height: 24px;
	font-size: 16px;
	color:rgba(0,0,0,0.85);
	font-weight: bold;
	margin-bottom: 12px;
}
.tc_img{
	position: absolute;
	left: -40px;
	width: 22px;
	height: 22px;
	
}
.close{
	position: absolute;
	width:65px;
	height:32px;
	background:rgba(24,144,255,1);
	border-radius:4px;
	bottom:24px;
	right: 32px;
	border: none;
	color: #fff;
}
.demo-ruleForm{
	width: 800px;
	height: 518px;
	background: #fff;
	margin: 39px auto 0;
}
.title{
	text-align: left;
	height: 54px;
	vertical-align: middle;
	line-height: 54px;
	border-bottom: 2px solid #EEEEEE;
}
.title span{
	display: inline-block;
	width:8px;
	height:20px;
	background:rgba(0,94,178,1);	
	margin:0 11px 0 13px;   
	vertical-align: middle; 
}
.title strong{
	display: inline-block;
	font-size:20px;
	line-height: 28px;
	font-weight:bold;
	color:rgba(0,94,178,1);
	vertical-align: middle;
}
.middle{
	width: 370px;
	height: auto;
	margin:20px auto 0;
}
.iptbox{
	width: 100%;
	height: 40px;
	position: relative;
	margin-bottom: 20px;		
}
.iptbox span{
	position: absolute;
	left: 0;
	line-height: 40px;
	width:56px;
	height:40px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(100,100,100,1);
}
.drag{
    position: relative;
    background-color: #e8e8e8;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-bottom: 25px;
}
.handler{
    width: 40px;
    height: 38px;
    border: 1px solid #ccc;
    cursor: move;
}
.handler_bg{
    background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
}
.handler_ok_bg{
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center;
}
.drag_bg{
    background-color: #7ac23c;
    height:40px;
    width: 0px;
}
.drag_text{
    position: absolute;
    top: 0px;
    width: 100%;text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select:none;
    -ms-user-select:none;
}
.add{
	position: relative;
	cursor: pointer;
	margin: 0 0 8px 70px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(0,0,0,0.65);
	line-height:32px;
	width:106px;
	height:32px;
	background:rgba(255,255,255,1) url(../../static/img/input.png) no-repeat;
	background-size:100%;	
}	
.file{
	position: absolute;
    left: -9999px;
}
label {
	position: absolute;
	top: 0;left: 0;right: 0;bottom: 0;
	z-index: 10; 
}
.note{
	font-size: 14px;
	text-align: left;
	text-indent: 70px;
	margin-bottom: 18px;
}
.note1{
	padding-left: 70px;
	font-size:13px;
	margin-bottom: 36px;
	text-align: left;
	color: #646464;
}
.down_load{
	color: #0076FF;
}
.btn{
	display: block;
	margin: 0 auto 23px;
	  width:160px;
	height:48px;
	background:#0076FF;
	border-radius:4px;
	border: none;
}

</style>



// WEBPACK FOOTER //
// src/components/ReturnPassword.vue